export const sparklinesSize = { width: 300, height: 40 };

const appConfig = { sparklinesSize };

export default appConfig;
